import { useEffect, useState } from "react";
import { api, trackVisit } from "../lib/api";
import PageHero from "../components/site/PageHero";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    trackVisit("faq");
    api.get("/faqs").then((r) => setFaqs(r.data));
  }, []);

  return (
    <div data-testid="faq-page">
      <PageHero eyebrow="Domande Frequenti" title="Risposte chiare," titleAccent="senza giri di parole." />

      <section className="py-16">
        <div className="max-w-3xl mx-auto px-6">
          <Accordion type="single" collapsible className="w-full space-y-3">
            {faqs.map((f) => (
              <AccordionItem key={f.id} value={f.id} data-testid={`faq-${f.id}`} className="luxe-card !border-white/10 px-6 rounded-none">
                <AccordionTrigger className="font-serif text-lg text-white hover:text-[var(--gold)] hover:no-underline py-5 text-left">
                  {f.question}
                </AccordionTrigger>
                <AccordionContent className="text-[var(--text-secondary)] leading-relaxed pb-5">
                  {f.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div className="mt-16 text-center">
            <p className="text-white/60 mb-4">Non hai trovato la risposta che cercavi?</p>
            <a href="/contatti" className="btn-gold">Contattaci direttamente</a>
          </div>
        </div>
      </section>
    </div>
  );
}
